export type DealKind = 'rental' | 'sale';

export interface StageDef {
  key: string;
  /** i18n key. */
  label: string;
}

const RENTAL: StageDef[] = [
  { key: 'token', label: 'stage.token' },
  { key: 'memo', label: 'stage.memo' },
  { key: 'agreement', label: 'stage.agreement' },
  { key: 'registration', label: 'stage.registration' },
  { key: 'brokerage', label: 'stage.brokerage' },
  { key: 'closed', label: 'stage.closed' },
];
const SALE: StageDef[] = [
  { key: 'token', label: 'stage.token' },
  { key: 'memo', label: 'stage.memo' },
  { key: 'closed', label: 'stage.closed' },
];

export function stagesFor(kind: DealKind): StageDef[] {
  return kind === 'rental' ? RENTAL : SALE;
}

const ORDER: Record<DealKind, Record<string, number>> = {
  rental: {
    open: 0,
    token_recorded: 1,
    memo_signed: 2,
    agreement_drafted: 3,
    registered: 4,
    closed: 5,
  },
  sale: { open: 0, token_recorded: 1, memo_signed: 2, closed: 3 },
};

/** The index of the stage a deal is working on. Past the last one means everything is done. */
export function stageIndex(kind: DealKind, state: string): number {
  return ORDER[kind][state] ?? 0;
}

export const FINISHED = ['closed', 'lost', 'cancelled'];
export const AFTER_MEMO = ['memo_signed', 'agreement_drafted', 'registered', 'closed'];
